// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
// App Specific
import Home from '@/components/LangGG/Home'
import TagPage from '@/components/LangGG/TagPage'
import GamePage from '@/components/LangGG/GamePage'
import Profile from '@/components/LangGG/Profile'
import Login from '@/components/LangGG/Login'
import PaymentError from '@/components/LangGG/PaymentError'
// Lang Specific
import LP from '@/components/LangGG/BA/LP'
import Deactivation from '@/components/LangGG/BA/Deactivation'
import Contact from '@/components/LangGG/BA/Contact'
import Terms from '@/components/LangGG/BA/Terms'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/tag/:name',
            name: 'TagPage',
            component: TagPage
        },
        {
            path: '/game/:id',
            name: 'GamePage',
            component: GamePage
        },
        {
            path: '/deactivation',
            name: 'Deactivation',
            component: Deactivation
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/gg/ba.js